import React, { useMemo } from 'react';
import { Box, CoveragePeriods, FlexListHeader, Inscription } from '@common-fe/common-fe';
import { uniqueId } from 'lodash';
import styled from 'styled-components';

import { ListItemBase } from '@/common/types';
import { EnrollmentCoverageInfoHint } from '@/modules/employee/EnrollmentDetails/EnrollmentDetailsAccountInfo/EnrollmentCoverageInfoHint';

const Wrapper = styled(Box)`
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.spacing4};
  }
`;

const CoveragePeriodsTable: React.FC<{
  coveragePeriods: CoveragePeriods[];
  externalDeductibleMet?: string;
}> = ({ coveragePeriods, externalDeductibleMet }) => {
  const headers: ListItemBase[] = useMemo(() => {
    const currentHeaders = [
      {
        key: 'period',
        title: 'Period',
      },
    ];
    return currentHeaders;
  }, []);
  return (
    <Box data-testid="coverage-periods-wrapper" background="module" pad="xs" round="container2Round">
      <FlexListHeader items={headers} thinMode />
      {coveragePeriods.map((item, index) => (
        <Wrapper
          key={uniqueId()}
          height="36px"
          border={{ color: 'border2' }}
          background="canvas"
          round="dropdownItemRound"
          margin={{ top: index === 0 ? 'spacing4' : '0px' }}
          pad={{ vertical: 'spacing8', horizontal: 'spacing24' }}
          direction="row"
          align="center"
          data-testid={`coverage-period-row-${index}`}
        >
          <Box
            height="24px"
            direction="row"
            align="center"
            data-testid={`coverage-period-row-${index}_period`}
          >
            <Inscription
              size="small"
              lineHeight="18px"
              style={{ fontWeight: 500 }}
              data-testid={`coverage-period-row-${index}_period-start`}
            >
              {item.startDate}
            </Inscription>
            &nbsp;-&nbsp;
            <Inscription
              size="small"
              lineHeight="18px"
              style={{ fontWeight: 500 }}
              data-testid={`coverage-period-row-${index}_period-end`}
            >
              {item.endDate}
            </Inscription>
          </Box>

          {(item?.limitedPeriods && item?.limitedPeriods.length) || externalDeductibleMet ? (
            <Box width={{ max: '16px', min: '16px' }} margin={{ left: 'spacing24' }}>
              <EnrollmentCoverageInfoHint
                limitedPeriods={item?.limitedPeriods}
                externalDeductibleMet={externalDeductibleMet}
                coveragePeriods={coveragePeriods}
              />
            </Box>
          ) : null}
        </Wrapper>
      ))}
    </Box>
  );
};

export default CoveragePeriodsTable;
